export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6295.abd8c063.jpg";